// import React, { useEffect, useState } from "react";
// import { Col, Container, Row } from "react-bootstrap";
// import { useParams } from "react-router-dom";
// import EventDetailsPage from "../components/eventsGallery/EventDetailsPage";
// import EventGalleryList from "../components/eventsGallery/EventGalleryList";
// import API from "../config/axios";
// import { api_paths } from "../config/api.paths";
// import { useDispatch, useSelector } from "react-redux";
// import { SET_LOADING } from "../redux/user";

// const EventGallery = () => {
//   const { eventId } = useParams();
//   const [events, setEvents] = useState([]);
//   const { loading } = useSelector((state) => state.USER_DATA);
//   const dispatch = useDispatch();

//   const fetchEvent = async () => {
//     try {
//       dispatch(SET_LOADING(true));

//       const response = await API.get(
//         api_paths.member.EVENTS.EVENT_GALLERY_PAGE.GET_LIST
//       );

//       const data = response.data?.payload?.result?.data || null;
//       // console.log("Event gallery data: ", data);

//       setEvents(data);
//     } catch (error) {
//       console.error("Error fetching event gallery:", error);
//     } finally {
//       dispatch(SET_LOADING(false));
//     }
//   };

//   useEffect(() => {
//     fetchEvent();
//     // eslint-disable-next-line
//   }, []);

//   if (eventId) {
//     return <EventDetailsPage eventId={eventId} />;
//   }

//   return (
//     <Container className="py-5">
//       <Row className="mb-4">
//         <Col lg={12}>
//           <div className="rsvp-header text-center">
//             <h1 className="mb-3 h1 text-main">Event Gallery</h1>
//             <p className="mb-0">Capturing memories from our community events</p>
//           </div>
//         </Col>
//       </Row>
//     <hr />
//       {!loading && events.length > 0 && <EventGalleryList data={events} />}

//       {/* <EventGalleryList /> */}
//     </Container>
//   );
// };

// export default EventGallery;

import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import EventDetailsPage from "../components/eventsGallery/EventDetailsPage";
import EventGalleryList from "../components/eventsGallery/EventGalleryList";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import { useDispatch, useSelector } from "react-redux";
import { SET_LOADING } from "../redux/user";

const EventGallery = () => {
  const { eventId } = useParams();
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);

  const { loading: globalLoading } = useSelector((state) => state.USER_DATA);
  const dispatch = useDispatch();

  // guard to prevent concurrent fetches
  const isFetchingRef = useRef(false);

  const LIMIT = 12;

  const fetchEventPage = async (pageToFetch = 1) => {
    // prevent concurrent fetches
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;

    // toggle loading states
    if (pageToFetch === 1) {
      setInitialLoading(true);
      dispatch(SET_LOADING(true)); // keep global loading behavior like before
    } else {
      setLoadingMore(true);
    }

    try {
      // call API with page & limit
      const response = await API.get(
        `${api_paths.member.EVENTS.EVENT_GALLERY_PAGE.GET_LIST}?page=${pageToFetch}&limit=${LIMIT} `
      );

      const data = response.data?.payload?.result?.data || [];
      const meta = response.data?.payload?.result?.meta || {};

      // Determine total pages (prefer meta.total_pages, else derive from total_count)
      let total_pages = 1;
      if (meta.total_pages != null) {
        total_pages = Number(meta.total_pages) || 1;
      } else if (meta.total_count != null) {
        total_pages = Math.max(1, Math.ceil(Number(meta.total_count) / LIMIT));
      }

      setTotalPages(total_pages);

      if (pageToFetch === 1) {
        setEvents(data);
        setPage(1);
      } else {
        // append (dedupe by _id just in case)
        setEvents((prev) => {
          const existing = new Set(prev.map((p) => p._id));
          const appended = data.filter((d) => !existing.has(d._id));
          return [...prev, ...appended];
        });
        setPage(pageToFetch);
      }
    } catch (error) {
      console.error("Error fetching event gallery:", error);
    } finally {
      isFetchingRef.current = false;
      if (pageToFetch === 1) {
        setInitialLoading(false);
        dispatch(SET_LOADING(false));
      } else {
        setLoadingMore(false);
      }
    }
  };

  useEffect(() => {
    fetchEventPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleViewMore = () => {
    if (page >= totalPages || isFetchingRef.current) return;
    const next = page + 1;
    fetchEventPage(next);
  };

  // If route contains eventId -> show details
  if (eventId) {
    return <EventDetailsPage eventId={eventId} />;
  }

  return (
    <Container className="py-md-4 py-2">
      <Row className="mb-md-4 mb-0 mt-3 mt-md-0">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="mb-3 h1 text-main">Events Gallery</h1>
            <p className="mb-0">Capturing memories from our community events</p>
          </div>
        </Col>
      </Row>

      <hr />
      <>
        {/* Event gallery list uses your existing component */}
        {!globalLoading && events.length > 0 && <EventGalleryList data={events} />}

        {/* No events */}
        {!globalLoading && events.length === 0 && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center my-5">
              <p>No events found.</p>
            </Col>
          </Row>
        )}

        {/* View More button */}
        {!initialLoading && !loadingMore && page < totalPages && events.length > 0 && (
          <div className="text-center mt-4">
            <Button onClick={handleViewMore} className="px-5 btn btn-orange-md" style={{ color: "#FFF" }}>
              View More
            </Button>
          </div>
        )}

        {/* Loading more indicator */}
        {loadingMore && (
          <div className="text-center mt-4">
            <Button disabled className="px-5 btn btn-orange-md" style={{ color: "#FFF" }}>
              Loading...
            </Button>
          </div>
        )}
      </>
    </Container>
  );
};

export default EventGallery;
